export class AuthConsts
{
  static AUTHORIZATION = "Authorization";

  static ACCESS_TOKEN = "access_token";
  static AUTHORIZATION_CODE = "authorization_code";
  static ACCESS_TOKEN_EXPIRY = "access_token_expiry";
  static EXP_TIME_AUTH_TOKEN = "exp_time_auth_token";

  static MESSAGE = "message";
  static SOURCE = "source";
  static IFX_PORTAL = "ifx_portal";
  static ASM_APP = "asm_app";

  // Message types
  static NAVIGATE_TO = "navigateTo";
  static GO_BACK = "goBack";
  static IFRAME_READY = "iframeReady";
  static AUTH_CONTEXT_READY = "authContextReady";
  static NAVIGATION_CONTEXT_READY = "navigationContextReady";


  static SELECTED_AIRLINE = "selectedAirline";
  static USER_INFO = "userInfo";

  static CONTENT_TYPE_JSON = {
    "Content-type": "application/json",
  };
  static CONTENT_TYPE_MULTIPART_FORM_DATA = {
    "Content-type": "multipart/form-data",
  };
}
